import { Enum } from 'enumify';

class AutosaveStatus extends Enum {}

AutosaveStatus.initEnum(['SCHEDULED', 'RUNNING', 'DONE']);

export default AutosaveStatus;
